import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BreadcrumbFour = (props) => {
    const { heading, path, title, desc, children } = props;
    const navigation = useNavigate()
    const image='https://images.pexels.com/photos/2388936/pexels-photo-2388936.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
    const sectionStyle = image ? {
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    } : {};

    const isImage = image ? "isImage-style" : "";

    return (
        <section className={`section breadcrumb-area overlay-dark ${isImage} d-flex align-items-center`} style={sectionStyle}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        
                            {children ? 
                                children
                                : (
                                <>
                                <div className="breadcrumb-content text-center">
                                    <h3 className="text-white text-uppercase mb-3" style={{fontSize: "3rem"}}>{title}</h3>
                                    <h4 className="text-white text-uppercase mb-3">{desc}</h4>
                                    <p className='text-white'>
                                        <span style={{cursor: "pointer"}} onClick={() => navigation("/")}>Home</span><span> / {path}</span>
                                    </p> 
                                    </div>
                                </>
                            )}
                       
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BreadcrumbFour;
